import { render, staticRenderFns } from "./changelog.vue?vue&type=template&id=a011211a"
import script from "./changelog.vue?vue&type=script&lang=ts"
export * from "./changelog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports